import React from 'react';
import { Icon } from '../../elements/icon';

const ThankYouDefault = ({ t, userName, onSubmit, isLoading }) => (
  <div className="t-flex t-flex-col t-items-center t-justify-center t-text-center t-pt-8">
    <h1 className="t-font-serif t-text-[30px] sm:t-text-4xl t-text-navy t-leading-tight t-mb-4 t-max-w-[380px]">
      {t('ThankYouQuizTitlePre')}
      {userName ? `, ${userName}` : ''}
      .<br />
      {t('ThankYouQuizTitlePost')}
    </h1>
    <p className="t-text-[14.5px] t-text-g500 t-leading-relaxed t-max-w-[380px] t-mb-7">
      {t('ThankYouQuizIntro')}
    </p>
    <div className="t-text-left t-mb-8 t-w-full t-max-w-[340px] t-mx-auto">
      <div className="t-flex t-items-center t-gap-3 t-py-3 t-text-[15px] t-font-medium t-text-navy">
        <Icon name="tealCheckCircle" size={22} raw /> {t('ThankYouQuizList1')}
      </div>
      <div className="t-flex t-items-center t-gap-3 t-py-3 t-text-[15px] t-font-medium t-text-navy">
        <Icon name="tealCheckCircle" size={22} raw /> {t('ThankYouQuizList2')}
      </div>
      <div className="t-flex t-items-center t-gap-3 t-py-3 t-text-[15px] t-font-medium t-text-navy">
        <Icon name="tealCheckCircle" size={22} raw /> {t('ThankYouQuizList3')}
      </div>
    </div>
    <button
      type="button"
      onClick={onSubmit}
      disabled={isLoading}
      className="t-w-full t-max-w-[380px] t-py-4 t-px-6 t-rounded-xl t-bg-quiz-teal t-text-white t-font-sans t-text-base t-font-bold t-border-0 t-cursor-pointer hover:t-bg-[#0e5c5d] hover:-t-translate-y-px hover:t-shadow-lg disabled:t-opacity-50"
    >
      {t('GenerateMyFormula')}
    </button>
    <p className="t-mt-5 t-text-[13px] t-italic t-font-semibold t-text-quiz-teal t-max-w-[300px] t-leading-relaxed">
      {t('JoinMembersFormula')}
    </p>
  </div>
);

export default ThankYouDefault;

